<template>
  <div class="overlay" @click.self="$emit('close')">
    <div class="modal">
      <!-- Header -->
      <div class="header">
        <div class="title">Select Date</div>
      </div>

      <!-- Wheel Picker -->
      <div class="wheel-picker-container">
        <div class="wheel-picker">
          <!-- Month -->
          <div class="wheel-column" ref="monthWheel">
            <div class="wheel-spacer"></div>
            <div
              v-for="(m, i) in months"
              :key="i"
              class="wheel-item"
              :class="{ selected: i === selectedMonth }"
              @click="selectedMonth = i"
            >
              {{ m }}
            </div>
            <div class="wheel-spacer"></div>
          </div>

          <!-- Day -->
          <div class="wheel-column" ref="dayWheel">
            <div class="wheel-spacer"></div>
            <div
              v-for="d in daysInSelectedMonth"
              :key="d"
              class="wheel-item"
              :class="{ selected: d === selectedDay }"
              @click="selectedDay = d"
            >
              {{ d }}
            </div>
            <div class="wheel-spacer"></div>
          </div>

          <!-- Year -->
          <div class="wheel-column" ref="yearWheel">
            <div class="wheel-spacer"></div>
            <div
              v-for="y in years"
              :key="y"
              class="wheel-item"
              :class="{ selected: y === selectedYear }"
              @click="selectedYear = y"
            >
              {{ y }}
            </div>
            <div class="wheel-spacer"></div>
          </div>
        </div>

        <!-- Footer Buttons -->
        <div class="wheel-footer">
          <button class="wheel-reset-footer" @click="resetDate">Reset</button>
          <button class="wheel-done-footer" @click="doneDate">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    language_id: Number
  },

  data() {
    const defaultDate = [2000, 1, 1]
    const [y, m, d] = this.value
      ? this.value.split('-').map(Number)
      : defaultDate

    return {
      selectedMonth: m - 1,
      selectedDay: d,
      selectedYear: y
    }
  },

  computed: {
    months() {
      const monthNames = {
        1: ['January','February','March','April','May','June','July','August','September','October','November','December'],
        2: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
      }
      return monthNames[this.language_id] || monthNames[1]
    },

    years() {
      const current = new Date().getFullYear()
      return Array.from({ length: current - 1900 + 1 }, (_, i) => 1900 + i)
    },

    daysInSelectedMonth() {
      return new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate()
    }
  },

  watch: {
    value() {
      this.scrollToSelected()
    }
  },

  mounted() {
    this.scrollToSelected()
  },

  methods: {

    //scroll to date jan 1 2000 on load
    scrollToSelected() {
      this.$nextTick(() => {
        // Month
        const monthColumn = this.$refs.monthWheel
        if (monthColumn) {
          const itemHeight = monthColumn.querySelector('.wheel-item').offsetHeight
          monthColumn.scrollTop = this.selectedMonth * itemHeight
        }

        // Day
        const dayColumn = this.$refs.dayWheel
        if (dayColumn) {
          const itemHeight = dayColumn.querySelector('.wheel-item').offsetHeight
          dayColumn.scrollTop = (this.selectedDay - 1) * itemHeight
        }

        // Year
        const yearColumn = this.$refs.yearWheel
        if (yearColumn) {
          const itemHeight = yearColumn.querySelector('.wheel-item').offsetHeight
          const yearIndex = this.years.indexOf(this.selectedYear)
          yearColumn.scrollTop = yearIndex * itemHeight
        }
      })
    },

    doneDate() {
      const mm = String(this.selectedMonth + 1).padStart(2,'0')
      const dd = String(this.selectedDay).padStart(2,'0')
      const yyyy = this.selectedYear
      this.$emit('select', `${yyyy}-${mm}-${dd}`)
    },

    resetDate() {
      this.selectedYear = 2000
      this.selectedMonth = 0
      this.selectedDay = 1
      this.scrollToSelected()
      this.$emit('reset', '2000-01-01')
    }
  }
}
</script>

<style scoped>

.overlay {
  position: fixed; inset: 0;
  position: fixed; 
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.modal {
  background: white;
  min-width: 320px;
  max-height: 400px;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.header { 
    text-align: center; 
    font-weight: bold; 
    margin-bottom: 12px;
  text-align: center; 
  font-weight: bold; 
  margin-bottom: 12px;
}

.wheel-picker-container {
  display: flex;
  flex-direction: column;
  height: 280px;
}

.wheel-picker {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.wheel-column {
  flex: 1;
  text-align: center;
  border-right: 1px solid #eee;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  height: 100%;
}

.wheel-column:last-child { border-right: none; }
.wheel-column:last-child { 
  border-right: none; 
}

.wheel-item {
  height: 36px;
  line-height: 36px;
  cursor: pointer;
  scroll-snap-align: center;
}

.wheel-item.selected {
  font-weight: bold;
  color: #750097;
}

.wheel-spacer {
  height: calc(50% - 18px);
}

.wheel-footer {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #eee;
  padding: 8px;
  background: #f9f9f9;
}

.wheel-done-footer {
  margin-top: 10px;
  background: #750097;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 6px 24px;
  cursor: pointer;
  font-weight: bold;
}

.wheel-reset-footer {
  margin-top: 10px;
  color: black;
  border: none;
  border-radius: 8px;
  padding: 6px 24px;
  cursor: pointer;
  font-weight: bold;
}
</style>
